import { environment } from '../../../environments/environment';

export type CollectionImageType = 'collection' | 'album' | 'card';

export class CollectionsImagesHelper {

  static readonly maxImageSize: number = 2 * 1024 * 1024;

  static hasImage(imageUpdatedAt: number | null): boolean {
    return !!imageUpdatedAt;
  }

  static getImageUrl(type: CollectionImageType, id: number, imageUpdatedAt: number | null): string {
    return `${environment.gameAssetsBaseUrl}collections/${type}/${id}.png?v=${imageUpdatedAt ?? 0}`;
  }

  static getImageFileError(file: File): string | null {
    if (file.type !== 'image/png') return 'Image must be a PNG file';
    if (file.size > CollectionsImagesHelper.maxImageSize) return 'Image must not exceed 2 MB';
    return null;
  }
}
